const BASE_URL = 'https://api.dev.auxo.dk/public';

export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${BASE_URL}/content/${collectionName}`);
    if (!response.ok) throw new Error(`Failed to fetch ${collectionName}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function fetchBySlug(lang, slug) {
  try {
    const url = `${BASE_URL}/by-slug/${lang}/${slug}`;
    console.log(`Fetching by slug: ${url}`);
    const response = await fetch(url);
    if (!response.ok) {
      console.error(`Fetch failed for slug ${slug}: ${response.status} ${response.statusText}`);
      throw new Error(`Failed to fetch slug: ${slug}`);
    }
    return await response.json();
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function fetchById(collectionName, entryId) {
  try {
    const response = await fetch(`${BASE_URL}/content/${collectionName}/${entryId}`);
    if (!response.ok) throw new Error(`Failed to fetch entry: ${entryId}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return null;
  }
}
